import { render } from "./ModalSmall.vue?vue&type=template&id=3eab34c0&scoped=true&ts=true"
import script from "./ModalSmall.vue?vue&type=script&lang=ts"
export * from "./ModalSmall.vue?vue&type=script&lang=ts"

import "./ModalSmall.vue?vue&type=style&index=0&id=3eab34c0&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eab34c0"]])

export default __exports__